import React from 'react';
import {DataHeaderStyled} from "../../styled/Resume";
import {useTheme} from "../UI/Theme/ThemeContext";
import {useNavigate} from "react-router-dom";


const DataHeader = ({activeStep}) => {
    const {themeName} = useTheme();
    const navigate = useNavigate();

    return (
        <DataHeaderStyled theme={themeName}>
            <ul>
                <li 
                    className={activeStep === 1 ? "active" : ""} 
                    onClick={() => { if (activeStep > 1) navigate("?customize"); }}
                    style={{ cursor: activeStep > 1 ? "pointer" : "default" }}
                >
                    Step 1: Customise
                </li>
                <li 
                    className={activeStep === 2 ? "active" : ""}
                    onClick={() => { if (activeStep > 2) navigate("?preview"); }}
                    style={{ cursor: activeStep > 2 ? "pointer" : "default" }}
                >
                    Step 2: Preview
                </li>
                <li className={activeStep === 3 ? "active" : ""}>
                    Step 3: Download
                </li>
            </ul>
        </DataHeaderStyled>
    )
}

export default DataHeader;